export default {
  ESTADO: 'Pará',
  SISTEMA: 'SICARF',
  SIGLA_ESTADO: 'PA',
  ORGAO: 'ITERPA',
  LOGO: 'static/logo.png',
  SHAPE_ESTADO: 'municipiosPara.json',
  COORDENADAS_ESTADO: [-4.446367, -52.448730],
  UTILIZA_ARCGIS: true,
  CAMADAS_ORTOFOTOS: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
}



// WEBPACK FOOTER //
// ./src/constants/pa/dadosEstado/geral.js